





















import Vue from 'vue'
import { BaseCardTitle } from '@/components'
import { PaymentMethodListItem } from './components'
import { IShipping, IPaymentMethod } from '@/models'
import { ACTIONS_ORDER, STORE_MODULES } from '@/enums'
import { createNamespacedHelpers } from 'vuex'

const { mapActions } = createNamespacedHelpers(STORE_MODULES.ORDER)

export default Vue.extend({
    name: 'BaseFormOrderPayment',

    components: { BaseCardTitle, PaymentMethodListItem },

    model: {
        prop: 'paymentMethod',
        event: 'update:payment-method',
    },

    props: {
        paymentMethod: Object as () => IPaymentMethod,
        shipping: {
            type: Object as () => IShipping,
            required: true,
        },
    },

    data: () => ({
        paymentMethods: undefined as undefined | IPaymentMethod[],
    }),

    async created() {
        this.paymentMethods = await this.fetchPaymentMethods(this.shipping)

        if (this.paymentMethods?.length === 1) {
            this.selectMethod(this.paymentMethods[0])
        }
    },

    methods: {
        ...mapActions({ fetchPaymentMethods: ACTIONS_ORDER.FETCH_PAYMENT_METHODS }),

        selectMethod(method: IPaymentMethod) {
            this.$emit('update:payment-method', method)
        },
    },
})
